var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"resize-container",style:({height: _vm.h + 'px'})},[_c('div',{staticClass:"resize-content",style:({height: _vm.h + 'px'})},[_vm._t("content")],2)]),_c('div',{staticClass:"resize-handle",style:({height: _vm.handleHeight + 'px'}),on:{"mousedown":_vm.start}})])
}
var staticRenderFns = []

export { render, staticRenderFns }